export const QUERY_CUSTOMIZATION = "QUERY_CUSTOMIZATION";
export const QUERY_PUBLIC_CUSTOMIZATION = "QUERY_PUBLIC_CUSTOMIZATION";
